import "./App.css";
import "./docs.css";
import { SiTelegram } from "react-icons/si";
import { IoCallSharp } from "react-icons/io5";

function App() {
  return (
    <div className="docs">
      <h3 className="open-text">Руководство по использованию</h3>
      <div className="doc-section">
        <h4>Для начала работы с интеграцией</h4>
        <p>Откройте regos.online в вашем браузере:</p>
        <a href="https://regos.online" target="_blank" rel="noreferrer">
          https://regos.online
        </a>
        <h4>Перейдите в раздел Настройки и безопасность.</h4>
        <p>Найдите группу Интеграции.</p>
        <p>В списке доступных интеграций выберите Item Checker.</p>
        <p>Под названием интеграции нажмите кнопку «Настройки».</p>
        <p>
          В открывшемся окне нажмите кнопку «Открыть», чтобы использовать
          интеграцию.
        </p>
      </div>
      <div className="footer-section">
        <h4>По поводу вопросов и желаний можете обратиться к:</h4>
        <p>
          <IoCallSharp /> +998 93 546 60 10
        </p>
        <p>
          <IoCallSharp /> +998 55 705 00 30
        </p>
        <p>
          <SiTelegram />
          <a
            href="https://t.me/Easytradesupport_bot"
            target="_blank"
            rel="noreferrer"
          >
            @EasyTradesupport_bot
          </a>
        </p>
      </div>
    </div>
  );
}

export default App;
